import moment from "moment"
import storePersist from "../../redux/storePersist"
import * as R from "ramda"
import _ from "lodash"
import { DecodedToken, decodeToken } from "./decode-jwt"

export const deepCopy = (obj: any) => JSON.parse(JSON.stringify(obj))

export const copyTextToClipBoard = async (text: string) => {
  await navigator.clipboard.writeText(text)
}

export const getFormattedDate = ({ date }: any) => (
  moment
    .utc(date)
    .format('YYYY-MM-DD hh:mm:ss a')
)

export const format = (date: any) => {
  if (date) {
    const localDateFormatted = moment(date).local()
      .format('YYYY-MM-DD hh:mm:ss a')
    return localDateFormatted
  }
  return ''
}

export const currency = (money: any) => {
  var metaTokenMetaData = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization;
  const countryCode = metaTokenMetaData.CountryCode;
  const languageCode = metaTokenMetaData.LanguageCode;
  const currencyCode = metaTokenMetaData.CurrencyCode;

  const moneyArr: any = _.split(
    money,
    '.'
  )

  let finalMoneyString = Intl.NumberFormat(
    `${languageCode}-${countryCode}`,
    {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
      maximumSignificantDigits: 3
    }
  ).format(moneyArr[0])

  if (moneyArr?.length > 1) {
    finalMoneyString += `.${moneyArr[1]}`
  }

  return finalMoneyString
}
export const getCurrencySymbol = (label: any) => {
  let currencySymbol: any = null;
  const countryCode = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization?.CountryCode;
  const languageCode = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization?.LanguageCode;
  const currencyCode = storePersist?.get("metaTokenMetaData")?.current?.items?.Localization?.CurrencyCode || 'INR'
  if (label?.length > 0 &&
    R.find((subString) => label.indexOf(subString) > -1)([
      'Price',
      'Cost',
      'Amount',
      'Amt',
      'Charge',
      'Charges',
      'MRP'
    ])
  ) {
    // const options = { style: 'currency', currency: currencyCode };
    // const us = new Intl.NumberFormat(languageCode, options);
    const valueWithCurrency = Number(0)?.toLocaleString(languageCode, {
      style: "currency",
      currency: currencyCode,
      minimumFractionDigits: 2
    });
    const valueWithoutCurrency = valueWithCurrency.replace(Number(0)?.toLocaleString(languageCode, {
      minimumFractionDigits: 2
    }), "")

    currencySymbol = valueWithoutCurrency
  }
  return currencySymbol
}
export const getAccountTypeChannalName = () => {
  // const token = storePersist?.get("accessToken")?.current?.JwtToken;
  const token = localStorage?.getItem("access-token");
  if (token) {
    const decodedToken: DecodedToken | null = decodeToken(token);
    if (decodedToken) {

      return decodedToken;
    } else {
      // Handle invalid token
      // Redirect to login page, show error message, etc.
      return null;
    }
  } else {
    // Handle case when token is not present
    // Redirect to login page, show error message, etc.
    return null;
  }
}

export const transformCardValues = (cardValues: any) => {
  const values = deepCopy(cardValues)
  const transformedValues: any = [];
  let ictr = 0
  R.map(
    (valueSet) => {
      transformedValues.push([])
      R.map(
        (value) => {
          transformedValues[ictr].push({
            [value.field]: value.value
          })
          return value
        },
        valueSet
      )
      transformedValues[ictr] = R.mergeAll(transformedValues[ictr])
      ictr += 1
      return valueSet
    },
    values
  )
  return transformedValues
}
const keyMapped = (data: any) => {
  let type = ''
  if (data === 'src') {
    type = 'image'
  } else if (data === 'video') {
    type = 'video'
  } else if (data === 'email') {
    type = 'email'
  } else if (data === 'phone') {
    type = 'number'
  } else if (data === 'whatsapp') {
    type = 'number'
  } else {
    type = 'text'
  }

  return type
}

export const transformBackCardValues = (cardValues: any) => {
  const values = deepCopy(JSON.parse(cardValues))
  const transformedValues: any = [];
  let ictr = 0
  R.map(
    (valueSet) => {
      transformedValues.push([])
      R.mapObjIndexed(
        (value, key) => {
          transformedValues[ictr].push({
            field: key,
            type: keyMapped(key),
            value
          })
        },
        valueSet
      )
      ictr += 1
      return valueSet
    },
    values
  )
  return JSON.stringify(transformedValues)
}

export function updateNestedValue(obj, path, value) {
  if (!path) {
    return obj
  }
  const keys = path.split('.');
  let current = obj;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    const isArrayIndex = !isNaN(key) && parseInt(key, 10) == key;

    if (isArrayIndex) {
      // If it's an array index, ensure the current level is an array
      if (!Array.isArray(current)) {
        current = [];
      }
    } else {
      if (!current[key] || typeof current[key] !== 'object') {
        current[key] = {};
      }
    }
    current = current[key];
  }

  current[keys[keys.length - 1]] = value;
  return obj;
}

export const getHostName = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return "onedigiit"
  } else {
    return window.location.hostname
  }
}

export const formatTagListData = (data: any) => {
  return _.map(data, (product: any) => {
    const item = {
      ValueId: product?.ValueId,
      Name: `${product?.Name} : ${product?.Value}`,
    };
    return item
  });
};


// export const getHostInfoFromUrl = async (request: Request) => {
//   const url = new URL(request.url);
//   console.log('Host info in URL: ', url)
//   if (url.hostname === 'localhost') {
//     return { bap_id: "onex.digiit.io", bap_uri: "https://onex.csp.digiit.io", bpp_id: "onex.digiit.io", bpp_uri: url.origin }
//   } else {
//     const newHost = url.hostname.replace(/(\.xe)?\.digiit\./i, ".csp.digiit.");
//     const bap_uri = `${url.protocol}//${newHost}`;
//     return {
//       bap_id: url.hostname,
//       bap_uri: bap_uri,
//       bpp_id: url.hostname,
//       bpp_uri: url.origin
//     }
//   }
// }

export const getOrigin = () => {
  const host = window.location.hostname
  if (host.includes(".xe.digiit.io") || host.includes(".xe.digiit.ai")) {
    const parts = host.split(".");
    const subdomain = parts[0]; // e.g., "agri"
    const tld = parts[parts.length - 1]; // "io" or "ai"
    return `https://${subdomain}.csp.digiit.${tld}`;
  }
else if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return "https://onedigiit.csp.digiit.io"
  } else {
    if(window.location.origin.includes('onex.digiit.io')){
      return "https://onedigiit.csp.digiit.io"
    }  else if(window.location.origin.includes('onedigiit.com')){
      return "https://onedigiit.csp.digiit.ai"
    } else if(window.location.origin.includes('one.digiit.ai')){
      return "https://digiitbiz.csp.digiit.ai"
    } else if(window.location.origin.includes('agri.onedigiit.com')){
      return "https://agri.csp.digiit.ai"
    } else if(window.location.origin.includes('itzserene.onedigiit.com')){ 
      return "https://itzserene.csp.digiit.ai"
    }else if(window.location.origin.includes('shipx.onedigiit.com')){ 
      return "https://ulip.csp.digiit.ai"
    }else if(window.location.origin.includes('enterprise.onedigiit.com')){ 
      return "https://enterprisedigiit.csp.digiit.ai"
    }else if(window.location.origin.includes('bonsecours.onedigiit.com')){ 
      return "https://bonsecours.csp.digiit.ai"
    }else if(window.location.origin.includes('cauverycollege.onedigiit.com')){ 
      return "https://cauverycollege.csp.digiit.ai"
    }else if(window.location.origin.includes('idhayacollege.onedigiit.com')){ 
      return "https://idhayacollege.csp.digiit.ai"
    }else if(window.location.origin.includes('kambancollege.onedigiit.com')){ 
      return "https://kambancollege.csp.digiit.ai"
    }else if(window.location.origin.includes('onedigiit.xe.digiit.io')){ 
      return "https://onedigiit.csp.digiit.io"
    }else if(window.location.origin.includes('seon.onedigiit.com')){ 
      return "https://seon.csp.digiit.ai"
    }else
      return window.location.origin.replace(/\.digiit\./, ".csp.digiit.")
    } 
}

// export const getOrigin = () => {
//   if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
//     return "https://onedigiit.csp.digiit.io"
//   } else {
//     if (window.location.origin.includes('onex.digiit.io')) {
//       return "https://onedigiit.csp.digiit.io"
//     } else if (window.location.origin.includes('one.digiit.ai')) {
//       return "https://onedigiit.csp.digiit.ai"
//     } else if (window.location.origin.includes('agri.onedigiit.com')) {
//       return "https://agri.csp.digiit.ai"
//     } else if (window.location.origin.includes('itzserene.onedigiit.com')) {
//       return "https://itzserene.csp.digiit.ai"
//     } else if (window.location.origin.includes('shipx.onedigiit.com')) {
//       return "https://ulip.csp.digiit.ai"
//     } else if (window.location.origin.includes('enterprise.onedigiit.com')) {
//       return "https://enterprisedigiit.csp.digiit.ai"
//     } else if (window.location.origin.includes('bonsecours.onedigiit.com')) {
//       return "https://bonsecours.csp.digiit.ai"
//     } else if (window.location.origin.includes('cauverycollege.onedigiit.com')) {
//       return "https://cauverycollege.csp.digiit.ai"
//     } else if (window.location.origin.includes('idhayacollege.onedigiit.com')) {
//       return "https://idhayacollege.csp.digiit.ai"
//     } else if (window.location.origin.includes('kambancollege.onedigiit.com')) {
//       return "https://kambancollege.csp.digiit.ai"
//     } else if (window.location.origin.includes('onedigiit.xe.digiit.io')) {
//       return "https://onedigiit.csp.digiit.io"
//     } else if (window.location.origin.includes('seon.onedigiit.com')) {
//       return "https://seon.csp.digiit.ai"
//     } else
//       return window.location.origin.replace(/\.digiit\./, ".csp.digiit.")
//   }
// }

export const getGatewayId = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return process.env.REACT_APP_GATEWAY_ID
  } else {
    return window.location.hostname
  }
}
export const getGatewayuri = () => {
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return process.env.REACT_APP_GATEWAY_URI
  } else {
    return window.location.origin
  }
}